import React, { FC, ReactNode } from 'react';
import { BodyElem } from './Body.styles';

interface IBody {
  children: ReactNode;
  className?: string;
}

const Body: FC<IBody> = ({ children, className }) => (
  <BodyElem id="BodyElem" {...{ className }}>
    {children}
  </BodyElem>
);

export default Body;
